module.exports = __webpack_public_path__ + "static/media/panihaas.acedad72.ogg";